import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModuleTypeService, ModuleType } from '../../../services/rest/module-type.service';
import { AuthUtils } from '../../../utils/AuthUtils';
import { PermissionTargetEnum } from '../../../enums/PermissionTargetEnum';
import { InputButtonIconType } from '../../core/button/button.utils';
import { ConfirmService } from '../../../services/confirm.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-module-type-table',
  templateUrl: './module-type-table.component.html',
  styleUrls: ['./module-type-table.component.scss'],
})
export class ModuleTypeTableComponent implements OnInit {
  InputButtonIconType = InputButtonIconType;
  moduleTypes: ModuleType[] = [];
  loading = true;
  userCanEdit: boolean = AuthUtils.canEdit(PermissionTargetEnum.MODULE_TYPE);

  constructor(
    private service: ModuleTypeService,
    private router: Router,
    private confirmService: ConfirmService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.service.getAll().subscribe((res) => {
      this.moduleTypes = res;
      this.loading = false;
    });
  }

  onCreate(): void {
    this.router.navigate(['/module-type/create']);
  }

  onEdit(item: ModuleType): void {
    this.router.navigate(['/module-type/' + item.id]);
  }

  onDelete(item: ModuleType): void {
    this.confirmService.confirm(
      'Modul-Typ löschen',
      `Wollen Sie den Modul-Typ ${item.name} (${item.code}) wirklich löschen?`,
      () => {
        this.service.delete(item.id!).subscribe(() => {
          this.messageService.addSuccessMessage('Modul-Typ erfolgreich gelöscht');
          this.load();
        });
      }
    );
  }
}
